import React, { useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import { loadPopularPost, loadPost } from "redux/modules/postSlice";
import LikeToggle from "../common/LikeToggle/index";

import {
  FlexDiv,
  RecommendedPost,
  RecmdCategory,
  RecmdContent,
  ReccommendedContainer,
  RecAside,
  SlideContainer,
} from "./RecommendedPostsStyle";
import { useDispatch } from "react-redux";

function RecommendedPosts({ currentCategory, currentPage }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadPopularPost());
  }, [dispatch]);

  const onClickLiked = () => {
    const payload = { category: currentCategory, page: currentPage };
    dispatch(loadPost(payload));
  };

  const popularPosts = useSelector((state) => state.post.popularPosts);

  const recommendedPost = (el) => {
    return (
      <RecommendedPost key={el.boardId + el.nickname}>
        <RecmdCategory>
          <span className="category">{el.category}</span>
          <span className="createAt">
            {el.createdAt.substr(0, 10).replaceAll("-", ".")}
          </span>
        </RecmdCategory>

        <Link to={`/boards/${el.boardId}`}>
          <RecmdContent>{el.content}</RecmdContent>
        </Link>

        <RecAside>
          <span className="nickName">{el.nickname}</span>
          <span className="aside__icons">
            <div className="likedDiv" onClick={onClickLiked}>
              <LikeToggle el={el} />
            </div>

            <div className="commentsDiv">
              <img className="comments" src="/img/comment.svg" alt="comments" />
            </div>
            <div>{el.commentCount}</div>
          </span>
        </RecAside>
      </RecommendedPost>
    );
  };

  return (
    <ReccommendedContainer>
      <FlexDiv>
        <SlideContainer>
          {popularPosts?.length > 0 ? (
            popularPosts?.map((el) => (
              <div key={el.boardId}>{recommendedPost(el)}</div>
            ))
          ) : (
            <div>인기게시물이 아직 없습니다.</div>
          )}
        </SlideContainer>
      </FlexDiv>
    </ReccommendedContainer>
  );
}

export default RecommendedPosts;
